import Vue from 'vue';
import Component from 'vue-class-component';
import Rating from 'common/components/Rating';
import SocialShare from 'components/SocialShare';
import currency from 'common/filters/currency';
import HeartIt from 'common/components/HeartIt';
import NewCarousel from 'components/NewCarousel';
import ProductShippingSelector from 'components/ProductShippingSelector';
import ReviewsBar from 'components/ReviewsBar';
import CartLimit from 'assets/graphql/queries/CartLimit.graphql';
import CartQuery from 'assets/graphql/queries/Cart.graphql';
import SiteConfigQuery from 'assets/graphql/queries/SiteConfig.graphql';
import getLastTld from 'common/services/utils/getLastTld';
import getParticipantsIcon from 'common/services/utils/getParticipantsIcon';
import PromoGrid from 'components/Modals/PromoGrid/PromoGrid.vue';
import { getRobotsByActivity } from 'common/utils/metainfo';

Vue.filter('currency', currency);

@Component({
  apollo: {
    cart: {
      query: CartQuery,
    },
    cart_limit: {
      query: CartLimit,
    },
    siteConfig: {
      query: SiteConfigQuery,
    },
  },
  props: {
    expirationDate: {
      type: String,
      required: true,
    },
    categoryColor: {
      type: String,
      required: true,
    },
    box: {
      type: Object,
      required: true,
    },
    activity: {
      type: Object,
      required: true,
    },
    isReserved: {
      type: Boolean,
      default: false,
    },
    changeToCreditAllowed: {
      type: Boolean,
      default: true,
    },
    isForSale: {
      type: Boolean,
      required: false,
      default: false,
    },
    boxName: {
      type: String,
      required: false,
      default: '',
    },
    isReservationBuy: {
      type: Boolean,
      default: false,
    },
    isRetailMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Rating,
    SocialShare,
    HeartIt,
    NewCarousel,
    ProductShippingSelector,
    ReviewsBar,
    PromoGrid,
  },
  metaInfo() {
    // Get the canonical URL without parameters
    const canonicalUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname;

    // Define the domain
    const domain = window.location.host;

    let newtitle = `Regalá ${this.activity.name} - Regalos Bigbox`;
    if (
      domain.includes('.cl') ||
      domain.includes('.com.mx') ||
      domain.includes('.com.co') ||
      domain.includes('.pe')
    ) {
      newtitle = `Regala ${this.activity.name} - Regalos Bigbox`;
    }

    const metatags = {
      title: newtitle,
      meta: [
        {
          name: 'description',
          content: this.activity.short_description,
          vmid: 'description',
        },
        { property: 'og:site_name', content: 'Bigbox', vmid: 'ogSiteName' },
        { property: 'og:title', content: newtitle, vmid: 'ogTitle' },
        { property: 'og:url', content: window.location.href, vmid: 'ogUrl' },
        { property: 'og:type', content: 'product', vmid: 'ogType' },
        {
          property: 'og:description',
          content: this.activity.short_description,
          vmid: 'description',
        },
        {
          property: 'og:image',
          content: this.activity.images[0].image,
          vmid: 'ogImage',
        },
        getRobotsByActivity(this.activity),
      ],
      link: [
        {
          rel: 'canonical',
          href: canonicalUrl, // Set the canonical URL without query parameters
          vmid: 'canonical',
        },
      ],
    };
    return metatags;
  },
})
export default class ActivityInformationComponent extends Vue {
  loading = false;
  showError = false;
  shipping = {
    type: 'digital',
    icon: 'Email2.svg',
    iconClass: 'Email2-icon',
    description: 'Envío digital por e-mail',
    isFree: true,
    isNew: false,
  };
  shippingFormats = {
    title: 'Tipos de envío:',
    options: [
      { text: 'Envío por e-mail', type: 'digital' },
      { text: 'Envío por Whatsapp', type: 'social' },
    ],
  };
  isMobile = null;
  maxMobileResolution = 768;
  isTravel = this.activity.comboactivity?.travelactivity !== undefined;

  get isCatalog() {
    return (
      this.activity.activity_view_config.is_catalog &&
      this.activity.activity_view_config.catalog_case
    );
  }

  get isCartFull() {
    if (this.cart) {
      return this.cart.items.length >= this.cart_limit;
    }
    return false;
  }

  created() {
    window.addEventListener('resize', this.checkBreakpoint);
    this.checkBreakpoint();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.checkBreakpoint);
  }

  checkBreakpoint() {
    this.isMobile = window.innerWidth <= this.maxMobileResolution;
  }

  get participantsIcon() {
    return getParticipantsIcon(this.activity.participants);
  }

  get country() {
    return getLastTld();
  }

  get activityUrl() {
    return `https://www.bigbox.com.${getLastTld()}${this.activity.product_url}`;
  }

  get hasMultipleImages() {
    return this.activity.images.length > 1;
  }

  updateShipping(shipping) {
    this.shipping = shipping;
  }

  accountGiftsRedirect() {
    this.$router.push({ name: 'accountGifts' });
  }
}
